
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resource-center/tag/[tag]",
      function () {
        return require("private-next-pages/resource-center/tag/[tag]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resource-center/tag/[tag]"])
      });
    }
  